// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.EyeHidden = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EyeHidden = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var EyeHidden = _exports.EyeHidden = function EyeHidden(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.33137 15.195C7.45596 14.8731 7.81793 14.7131 8.13983 14.8377C8.76167 15.0784 9.38764 15.2081 10.0009 15.2081C10.3461 15.2081 10.6259 15.4879 10.6259 15.8331C10.6259 16.1783 10.3461 16.4581 10.0009 16.4581C9.21082 16.4581 8.43179 16.2911 7.68863 16.0034C7.36672 15.8788 7.20677 15.5169 7.33137 15.195Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.6989 9.83999C18.0026 10.0042 18.1156 10.3834 17.9514 10.687C17.1251 12.2152 15.9479 13.6454 14.5839 14.6994C13.2235 15.7508 11.6362 16.4581 10 16.4581C9.65482 16.4581 9.375 16.1783 9.375 15.8331C9.375 15.4879 9.65482 15.2081 10 15.2081C11.2763 15.2081 12.6015 14.6517 13.8196 13.7103C15.0342 12.7717 16.1015 11.4802 16.8519 10.0925C17.0161 9.78886 17.3953 9.67581 17.6989 9.83999Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.4925 6.95885C15.755 6.73467 16.1495 6.7657 16.3737 7.02817C16.976 7.73331 17.5133 8.50444 17.9507 9.31349L17.951 9.314C18.1818 9.74172 18.1818 10.259 17.951 10.6867C17.7871 10.9905 17.408 11.1039 17.1042 10.94C16.8004 10.7761 16.687 10.3969 16.8509 10.0932C16.8818 10.036 16.8818 9.96496 16.851 9.90772C16.4585 9.18188 15.9725 8.48312 15.4232 7.84002C15.199 7.57755 15.2301 7.18304 15.4925 6.95885Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.2766 3.72456C16.5207 3.96864 16.5207 4.36437 16.2766 4.60845L4.60991 16.2751C4.36583 16.5192 3.9701 16.5192 3.72603 16.2751C3.48195 16.031 3.48195 15.6353 3.72603 15.3912L15.3927 3.72456C15.6368 3.48048 16.0325 3.48048 16.2766 3.72456Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.4143 8.5852C10.6334 7.80428 9.36661 7.80428 8.58569 8.5852C7.80477 9.36613 7.80477 10.6329 8.58569 11.4138C8.82977 11.6579 8.82977 12.0536 8.58569 12.2977C8.34161 12.5418 7.94589 12.5418 7.70181 12.2977C6.43273 11.0286 6.43273 8.9704 7.70181 7.70132C8.97089 6.43224 11.0291 6.43224 12.2982 7.70132C12.5423 7.9454 12.5423 8.34113 12.2982 8.5852C12.0541 8.82928 11.6584 8.82928 11.4143 8.5852Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.41582 5.30032C6.77632 4.24881 8.36363 3.5415 9.99979 3.5415C11.6364 3.5415 13.2251 4.24947 14.5856 5.3022C14.8586 5.51343 14.9087 5.90598 14.6974 6.17898C14.4862 6.45197 14.0937 6.50204 13.8207 6.29081C12.6029 5.34854 11.2765 4.7915 9.99979 4.7915C8.72345 4.7915 7.39826 5.34795 6.18022 6.28935C4.96561 7.22811 3.89831 8.51977 3.14793 9.90788L2.59812 9.61067L3.14818 9.90743C3.1173 9.96466 3.11727 10.0357 3.1481 10.0929C3.89846 11.4801 4.96512 12.7707 6.17889 13.7097C6.4519 13.9209 6.50201 14.3134 6.2908 14.5864C6.07959 14.8594 5.68705 14.9096 5.41403 14.6983C4.05126 13.6441 2.87468 12.2149 2.04839 10.6872L2.04807 10.6866C1.81731 10.2589 1.81731 9.74163 2.04807 9.31391L2.04832 9.31346C2.87461 7.7849 4.05189 6.35448 5.41582 5.30032Z",
      fill: "currentColor"
    }));
  };
});
